import { forwardRef } from "react";

import Icon from "@/components/Icon";
import LunaSearchingSVG from "./LunaSearchingIcon.svg.jsx";
import type { IconProps } from "@/components/Icon/Icon";

const LunaSearchingIcon = forwardRef<
  SVGSVGElement,
  Omit<IconProps, "SvgComponent">
>((props, ref) => {
  return <Icon ref={ref} SvgComponent={LunaSearchingSVG} {...props} />;
});

export default LunaSearchingIcon;
